import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type DriverInitialStateType = {
  subTab: number
}

const initialState: DriverInitialStateType = {
  subTab: 0,
}

const WorkSlice = createSlice({
  name: 'workSlice',
  initialState,
  reducers: {
    commitSubTabChange: (state, action: PayloadAction<number>) => {
      state.subTab = action.payload
    },
  },
})

export const { commitSubTabChange } = WorkSlice.actions

export default WorkSlice.reducer
